import Sms from 'ofcold-security-code/src/security.vue';
import { BackButton, ContainerForm, Hint } from '@/components';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { IConfirm, IConfirmByPhone, IRegistrationTranslation } from '@/types';
import { VForm } from 'vuetify/lib/components';

@Component({
  name: 'ConfirmByPhone',
})
export default class ConfirmByPhone extends Vue implements IConfirmByPhone {
  @Prop({type: String, default: 'phone'}) public readonly type!: string;
  @Prop({type: String, default: ''}) public readonly errorMessagePopup!: string;
  @Prop({type: Boolean, default: true}) public readonly showBackButton!: boolean;
  @Prop({type: Array, default: () => []}) public readonly resendThrottle!: number[];
  @Prop({type: Object, default: () => {}}) public readonly translations!: IRegistrationTranslation;
  @Prop({type: String, default: ''}) public readonly userEnterPhone!: string;
  @Prop({type: String, default: ''}) public readonly login2faCode!: string;
  @Prop({type: String, default: ''}) public readonly resendError!: string;

  public hasErrors;
  public showButton: boolean = false;
  public throttle;

  private code: string = '';

  public get t(): IConfirm {
    return this.translations.confirm;
  }

  public nextTimeInterval(): void {
    const it = this.throttle.next();
    this.showButton = false;
    if (!it.done) {
      setTimeout(() => this.showButton = !it.done, it.value * 1000);
    }
  }

  public created() {
    this.throttle = this.resendThrottle[Symbol.iterator]();
    this.nextTimeInterval();
  }

  public mounted() {
    (this.$refs.code as Vue).$el.getElementsByTagName('input').item(0)?.focus();
  }

  public render(createElement: CreateElement): VNode {

    const phone: VNode = createElement('span', {
      style: {
        display: 'inline-flex',
      },
    }, this.userEnterPhone);

    const back = this.showBackButton && createElement(BackButton, {
      slot: 'over',
      props: {
        name: this.t.backButtonName,
      },
      class: ['back-button'],
    });

    const userMessage: VNode = createElement('div', {
      class: {
        'flex-center': true,
      },
      style: {
        'width': '100%',
        'margin-top': '40px',
        'margin-bottom': '40px',
        'line-height': '24px',
        'text-align': 'center',
      },
    }, [createElement('p', [this.t.subTitle, ' ', this.userEnterPhone && phone])]);

    const retryCodeLink  = this.showButton && !this.resendError.length && createElement(Hint, {
      props: {
        text: this.t.hint,
      },
      style: {
        'align-self': 'center',
        'margin-top': '19px',
      },
      slot: 'bottom',
      nativeOn: {
        click: (): void => {
          this.$emit('action:resend', this.login2faCode);
          this.nextTimeInterval();
        },
      },
    });

    const resendError = !!this.resendError.length && createElement('div', {
      class: 'error',
      slot: 'bottom',
      style: {
        'align-self': 'center',
        'margin-top': '19px',
      },
    }, this.resendError);

    const codeComponent: VNode = createElement(Sms, {
      props: {
        value: this.code,
        securityCodeLength: 4,
      },
      on: {
        input: (value) => this.code = value,
      },
      ref: 'code',
    });

    const button: VNode = createElement('button', {
      style: {
        'margin-top': '40px',
      },
      class: {
        'orange-big-button': true,
      },
      attrs: {
        disabled: this.hasErrors,
        type: 'submit',
      },
      on: {
        click: (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.$emit('action', {
            id: this.login2faCode,
            sms_code: this.code,
          });
        },
      },
    }, this.t.buttonText);

    const errorPopup: VNode = createElement('div',
      {
        class: ['error-popup', 'error'],
      },
      [this.errorMessagePopup]);

    const form: VNode = createElement(VForm,
      {
        class: {
          'flex-center': true,
          'flex-column': true,
        },
        style: {
          'width': '100%',
        },
      },
      [userMessage, codeComponent, errorPopup, button]);

    return createElement(ContainerForm, {
        class: 'confirm-phone',
      },
      [
        back,
        this.$slots.close,
        this.$slots.title,
        form,
        retryCodeLink,
        resendError,
      ]);
    }

}
